import { createStore } from 'vuex'


// import modules
import moduleHome from './home'
import moduleApps from './apps'
import moduleTorneo from './torneo'
import moduleUser from './user'
import moduleEquipo from './equipo'
import modulePartido from './partido'
import moduleTools from './dstools'

export default createStore({
  modules: {
    moduleUser,
    moduleHome,
    moduleApps,
    moduleTorneo,
    moduleEquipo,
    modulePartido,
    moduleTools,
  }
})
